import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {DetailPage} from './detail.page';
import {CanDeactivateGuard} from '../../provider/deactivate-guard/deactivate-guard.guard';

const routes: Routes = [
	{
		path: '',
		component: DetailPage,
		canDeactivate: [CanDeactivateGuard]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
	providers: [CanDeactivateGuard]
})
export class DetailPageRoutingModule {
}
